import { MenuItem, MenuService, UpdateMenuItemData } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useUpdateNavigationItem(
  mutationOptions?: UseMutationOptions<MenuItem, HttpError, UpdateMenuItemData>,
) {
  return useMutation({
    mutationFn: MenuService.updateMenuItem,
    ...mutationOptions,
  });
}

export { useUpdateNavigationItem };
